export enum TwoFactorAuthType {
  GOOGLE = 'GOOGLE',
  EMAIL = 'EMAIL',
  BOTH = 'BOTH',
}
